import React from 'react';
import Hex from '../../map/Hex.js';
import { createListOfAllVariants, createVariantGroups, } from '../utils/withRotation.js';
import Stone1 from './variant/Stone1.js';
import { TERRAIN_COLOR_PLAIN } from '../colors.js';
const basicVariants = {
    default: Stone1,
    stone1: Stone1,
};
export const variantGroups = createVariantGroups(Object.keys(basicVariants));
const variants = createListOfAllVariants(basicVariants);
function BridgeHex({ style = {}, children, ...props }) {
    let variantName = props.graphicalVariant ?? 'default';
    if (variants[variantName] === undefined) {
        variantName = 'default';
    }
    let Variant = variants[variantName] ?? null;
    return (React.createElement(Hex, { ...props, style: {
            ...style,
            fill: TERRAIN_COLOR_PLAIN,
        } },
        React.createElement(Variant, { ...props }),
        children));
}
export const graphicalVariants = Object.keys(variants);
export default BridgeHex;
